import React from 'react';

const ImageModal = ({ imageUrl, closeModal }) => {
    return (
        <div className="modal fade show" id="image-modal" tabIndex={-1} style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        <img src={imageUrl} alt="Attachment" style={{ maxWidth: '100%', height: 'auto' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageModal;
